import { render, staticRenderFns } from "./MisConstancias.vue?vue&type=template&id=55d80261&scoped=true"
import script from "./MisConstancias.vue?vue&type=script&lang=js"
export * from "./MisConstancias.vue?vue&type=script&lang=js"
import style0 from "./MisConstancias.vue?vue&type=style&index=0&id=55d80261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d80261",
  null
  
)

export default component.exports